export default function ForbiddenPage() {
  return (
    <div>
      <h1>403 — Доступ заборонено</h1>
      <p>У вас немає прав для перегляду цієї сторінки.</p>
    </div>
  );
}
